import { useCallback, useMemo } from 'react'

import { trackClientEvent } from 'analytics/analytics'

import CategoryTile from 'LuxKit/CategoryTile'
import styled from 'styled-components'
import { rem } from 'polished'
import type { CategoryData } from './types'

const CategoryWrapper = styled(CategoryTile)`
  width: ${rem(180)};
`

interface Props {
  category: CategoryData
  actionText: string
  toUrl?: string
  trackingSubject?: string
}

function HotelPageCategoryTile(props: Props) {
  const { category, actionText, toUrl, trackingSubject } = props

  const image = useMemo((): App.Image => ({
    id: category.imageId,
    title: category.name,
  }), [category])
  const handleClick = useCallback(() => {
    trackClientEvent({
      action: 'pressed',
      subject: trackingSubject ?? `hotel_explore_category_${category.name.toLowerCase().replaceAll(' ', '_')}`,
      category: 'vertical_page',
      type: 'interaction',
    })
  }, [category.name, trackingSubject])

  return <CategoryWrapper
    onClick={handleClick}
    to={toUrl}
    image={image}
    heading={category.name}
    subHeading=""
    align="top"
    callToAction={actionText}
  />
}

export default HotelPageCategoryTile
